import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Page from "src/components/Page";
import { BaseTable } from "src/components/BaseTable/BaseTable";
import { refundColumns } from "./Refund.constant";
import enums, { FEATURE } from "src/util/enums";
import { differenceInHours } from "date-fns";
import { useSelector } from "react-redux";

//hooks, actions
import { useAccess } from "src/hooks/useAccess.hook";
import { useList } from "src/hooks/useFetch.hook";
import { useMutate } from "src/hooks/useFetch.hook";
import { useDispatch } from "react-redux";
import { alertSlice } from "src/store/alert/alert.slice";

//urls
import { refundUrl } from "src/react-query/endPoints";
import { useListControls } from "src/hooks/useListControls.hook";

const Refund = () => {
  const teamId = useSelector(state => state.teams.teamId);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const refundRef = useRef({ selectedRows: [] });
 // const { data, isLoading, refetch } = useList("refund", true);
    
  // Use pagination controls without search
  const {
    pagination,
    handlePageChange,
    handlePageSizeChange,
    updateTotal,
  } = useListControls(10);
  
  // Use paginated list hook for data fetching
  const { data: refundResponse, isLoading, refetch } = useList(
    'refundPaginated',
    true,
    pagination.page,
    pagination.pageSize,
  );

  const refundData = refundResponse?.data || [];
  const totalRefunds = refundResponse?.totalCount || 0;
  
  // Update total when data changes
  useEffect(() => {
    updateTotal(totalRefunds);
  }, [refundResponse, updateTotal, totalRefunds]);

  const { mutateAsync } = useMutate('refund');
  const hasReadOnlyAccess = useAccess(FEATURE.REFUND, "V");
  const updateAccess = useAccess(FEATURE.REFUND, "U");

  const onRefundAllClick = async () => {
    const { actions: { setAlert } } = alertSlice;
    const { current: { selectedRows } } = refundRef;
    const rows = selectedRows.filter((r) => !r.refundStatus);
    if (!rows.length) {
      dispatch(setAlert({
        open: true,
        message: "Please select row to bulk refund",
        severity: enums.SEVERITY.ERROR,
      }));
      return;
    }

    await mutateAsync({
      url: refundUrl(teamId),
      method: 'POST',
      body: { 
        refundBody: selectedRows.map((select) => ({ 
          transactionId: select.transactionId,  
          ocppIdTag: select.tag
        }))
      }
    }, { onSuccess: () => refetch() });
  }

  const onTableStateChange = (state) => {
    const { selection, rows: { idRowsLookup } } = state;
    let { current } = refundRef;
    current.selectedRows = selection.map((select) => idRowsLookup[select]);
  }

  const isRowSelectable = (params) => (hasReadOnlyAccess && 
    differenceInHours(new Date(), new Date(params.row.startDate)) <= 24 && 
    enums.REFUND_STATUS.PROCESSED !== params.row.refundStatus);

    const isReadOnly = useAccess(FEATURE.REFUND, "R");

    const rowOrCellClickRedirect = ({ id, field }) => {
      // if(isReadOnly) return;
      if (field !== 'Refund')
        navigate(`/refund/${id}`);
    };

  return (
    <Page title="Refund | Smart-CMS">
      <Card sx={{ p: 2 }}>
        {/* <Box className="data-grid-actions mb-3 text-right">
          {updateAccess && hasReadOnlyAccess && 
          <Button variant="contained" size="medium" onClick={onRefundAllClick}>
            Refund All
          </Button>}
        </Box> */}
        <BaseTable
          rows={refundData || []}
          columns={refundColumns(refetch, hasReadOnlyAccess, isReadOnly, updateAccess)}
          loading={isLoading}
          getRowId={(row) => row.transactionNumber}
          onStateChange={onTableStateChange}
          checkboxSelection={false}
          disableSelectionOnClick={false}
          isRowSelectable={isRowSelectable}
          rowOrCellClickRedirect={rowOrCellClickRedirect}
          isReadOnly={isReadOnly}

           // Pagination props
          page={pagination.page}
          pageSize={pagination.pageSize}
          rowCount={pagination.total}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          serverRowFetcher
          pagination={true}
          rowsPerPageOptions={[5, 10, 20, 50]}
        />
      </Card>
    </Page>
  );
};

export default Refund;